import {AnalysisGraphQL, AnalysisViewGraphQL} from 'analysis-tool/AnalysisTypes';
import {isTopLevelAnalysisView} from 'analysis-tool/data-view/AnalysisViewUtils';
import {DataViewActionInput} from 'analysis-tool/data-view/DataViewContext';
import {RightSidebarItemState} from 'analysis-tool/header-options/DataFrameHeaderMenuUtil';
import {getDataFrameHeaderMenuOptions} from 'analysis-tool/header-options/GetDataFrameHeaderMenuOptions';
import {DataFrameHeaderMenuOptions} from 'data-frames/header-menu/DataFrameHeaderMenuOptions';
import {getChildStepsForDataFrame} from 'pipelines/StepLineageUtils';
import {getLegacyStepFromAnalysis} from 'pipelines/StepUtil';

export default function getDataFrameColumnHeaderActions(
  analysis: AnalysisGraphQL,
  analysisClientStateId: string,
  view: AnalysisViewGraphQL,
  rightSidebarItemState: RightSidebarItemState
): (input: DataViewActionInput) => DataFrameHeaderMenuOptions | null {
  return ({persistedDataFrame}: DataViewActionInput) => {
    if (persistedDataFrame == null || !isTopLevelAnalysisView(view)) {
      return null;
    }

    const dataFrameId = persistedDataFrame.id;

    const lastNode = view.lineage[view.lineage.length - 1];
    const legacyLastStep = getLegacyStepFromAnalysis(analysis, lastNode.step);
    const stepOutputReference = view.lineage[view.lineage.length - 1].stepOutputReference;

    let outputDataReferences: Array<{stepId: string; stepDataName: string}> | undefined;
    const childSteps = getChildStepsForDataFrame(analysis, legacyLastStep, dataFrameId);
    if (childSteps.length > 0) {
      outputDataReferences = childSteps.flatMap((childStep) =>
        childStep.inputStepDatas
          .filter((stepData) => stepData.dataFrames.some((dataFrame) => dataFrame.id === dataFrameId))
          .map((inputStepData) => ({
            stepId: childStep.id,
            stepDataName: inputStepData.name,
          }))
      );
    }
    return getDataFrameHeaderMenuOptions(
      analysis,
      analysisClientStateId,
      legacyLastStep,
      {
        stepId: legacyLastStep.id,
        stepDataName: stepOutputReference!.outputStepData.name,
      },
      dataFrameId,
      outputDataReferences,
      rightSidebarItemState
    );
  };
}
